module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/carousel_arrow-1231efbdf4499119d6dd532acb403925.svg";